import { EventBroker } from "@frontend/lib/utils/event-broker";

export const EVENTS = {
  INIT: 'INIT'
}

export const generateThumbnailEventBroker = new EventBroker();
